module.exports = __webpack_public_path__ + "static/media/personal_protective_equipment.49c1ac04.svg";